import useSWR from "swr";
import { SWRApiError, swrConfigOptions, useFetcher } from "./swr";
import { mapRawToDesign, mapRawToStructureSummary } from "@/mappers/designXML";
import { RawStructureSummary } from "@/types/structure";
import { RawStructure } from "@/types/designs";

export const useDesignXML = (maskId?: string, isCustom: boolean = false) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawStructureSummary[], SWRApiError>(
    maskId ? { url: `/structures/view-design-summaries/${maskId}` } : null,
    fetcher,
    swrConfigOptions,
  );

  const mappedData = data.map(mapRawToStructureSummary);

  return {
    data: mappedData.filter((x) => x.isCustom === isCustom),
    ...rest,
  };
};

export const useStructure = (structureId?: string) => {
  const fetcher = useFetcher();

  const { data, ...rest } = useSWR<RawStructure, SWRApiError>(
    structureId ? { url: `/structures/${structureId}` } : null,
    fetcher,
    swrConfigOptions,
  );

  return {
    data: data ? mapRawToDesign(data) : null,
    ...rest,
  };
};
